import React from 'react';
import { NumericalColumn, CustomColumn, StringColumn } from 'baseui/data-table';
import { useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';
import { Button, KIND } from 'baseui/button';
import { StyledLink } from 'baseui/link';
import _toLower from 'lodash/toLower';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _startsWith from 'lodash/startsWith';
import _toString from 'lodash/toString';

import { EMPTY_STRING, GLOBAL_THEME } from 'commons-ui';
import { USER_PROFILE_RESOURCES, PAGE_NAMES } from 'constant';

export const COL_NAMES = {
	tournamentId: 'ltid',
	cgrid: 'cgrid',
	mttid: 'mttid',
	type: 'name',
	entryFee: 'entryFee',
	prize: 'prizePot',
	result: 'result',
	ticketRaised: 'ticketRaised',
	playingAttempt: 'playingAttempt',
	pwfInviteId: 'pwfInviteId',
	gameType: 'gameType'
};

export const columnConfigs = [
	CustomColumn({
		title: 'Tournament ID/PWF Invite ID',
		maxWidth: 300,
		mapDataToValue: (data: any) => ({
			[COL_NAMES.tournamentId]: data[COL_NAMES.tournamentId],
			[COL_NAMES.mttid]: data[COL_NAMES.mttid],
			[COL_NAMES.cgrid]: data[COL_NAMES.cgrid],
			[COL_NAMES.playingAttempt]: data[COL_NAMES.playingAttempt],
			[COL_NAMES.pwfInviteId]: data[COL_NAMES.pwfInviteId],
			[COL_NAMES.gameType]: data[COL_NAMES.gameType]
		}),
		renderCell: (params: any) => {
			const {
				value: { ltid, mttid, cgrid, playingAttempt, pwfInviteId, gameType }
			} = params;
			const history = useHistory();

			const handleOnClick = (event: any) => {
				event.preventDefault();
				event.stopPropagation();
				const currentSearch = _get(history, ['location', 'search'], '');
				if (!_isNil(pwfInviteId)) {
					history.push({
						pathname: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.gameplay}/details`,
						search: !_isEmpty(currentSearch)
							? `${currentSearch}&pwfInviteId=${pwfInviteId}&gameType=${gameType}`
							: `?pwfInviteId=${pwfInviteId}&gameType=${gameType}`
					});
				} else if (!_isNil(ltid)) {
					if (!_isNil(cgrid)) {
						history.push({
							pathname: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.gameplay}/details`,
							search: !_isEmpty(currentSearch)
								? `${currentSearch}&ltid=${ltid}&cgrid=${cgrid}`
								: `?ltid=${ltid}&cgrid=${cgrid}`
						});
					} else {
						history.push({
							pathname: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.gameplay}/details`,
							search: !_isEmpty(currentSearch)
								? `${currentSearch}&ltid=${ltid}&playingAttempt=${playingAttempt}`
								: `?ltid=${ltid}&playingAttempt=${playingAttempt}`
						});
					}
				} else if (!_isNil(mttid)) {
					history.push({
						pathname: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.gameplay}/details`,
						search: !_isEmpty(currentSearch) ? `${currentSearch}&mttid=${mttid}` : `?mttid=${mttid}`
					});
				}
			};

			return (
				<Button
					kind={KIND.tertiary}
					onClick={handleOnClick}
					overrides={{
						Root: {
							style: ({ $theme }) => ({
								color: $theme.colors.primaryA,
								height: '100%',
								width: '100%',
								fontSize: '12px',
								fontWeight: 'normal'
							})
						}
					}}>
					<StyledLink>{ltid || mttid || pwfInviteId}</StyledLink>
				</Button>
			);
		},
		textQueryFilter: (textQuery: string, data: { ltid?: number; mttid?: number }): boolean => {
			return _startsWith((data.ltid || data.mttid || '').toString(), `${textQuery}`);
		}
	}),
	StringColumn({
		title: 'Type',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.type]
	}),
	StringColumn({
		title: 'Playing attempt',
		maxWidth: 200,
		mapDataToValue: (data: any) => _toString(data[COL_NAMES.playingAttempt] || '')
	}),
	NumericalColumn({
		title: 'Entry fee (₹)',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.entryFee]
	}),
	StringColumn({
		title: 'Prize pot (₹)',
		maxWidth: 200,
		mapDataToValue: (data: any) => _toString(data[COL_NAMES.prize]) || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Result',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.result],
		renderCell: (params: any) => {
			const { value } = params;
			const [css] = useStyletron();
			let color = GLOBAL_THEME.Colors.black;
			const lowerCaseValue = _toLower(value);

			if (lowerCaseValue === 'won') {
				color = GLOBAL_THEME.Colors.textGreen;
			} else if (lowerCaseValue === 'lost') {
				color = GLOBAL_THEME.Colors.textRed;
			}
			return (
				<div
					className={css({
						color,
						height: '100%',
						width: '100%',
						paddingLeft: '10px'
					})}>
					{value}
				</div>
			);
		}
	})
];
